import { useSelectedTypeDefObjectNamesForTranslation } from '../../crmObjects/hooks/useSelectedObjectTypeDef';
import { useIsObjectRecordCreatorEnabled } from '../../objectBuilder/hooks/useIsObjectRecordCreatorEnabled';
import { useImport } from './ImportButton';
import { getCreateAccessScopes } from './CreateObjectButton';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Button } from 'foundations-components/transitional/components/Button';
import { Column } from 'foundations-components/transitional/components/Column';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import PermissionTooltip from 'customer-data-objects-ui-components/permissions/PermissionTooltip';
import unescapedText from 'I18n/utils/unescapedText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CreateObjectDropdown = ({
  isDisabled,
  onCreateObject,
  hasAllScopes,
  typeDef
}) => {
  const {
    pluralForm,
    pluralFormLowercase
  } = useSelectedTypeDefObjectNamesForTranslation();
  const {
    isImportDisabled,
    handleClick: handleImportClick,
    disabledTooltipKey
  } = useImport({
    typeDef,
    hasAllScopes
  });
  return /*#__PURE__*/_jsx(Column, {
    marginInlineStart: "200",
    children: /*#__PURE__*/_jsx(Dropdown, {
      buttonUse: "primary",
      buttonSize: "small",
      buttonText: unescapedText('index.header.addObjectsDropdown', {
        pluralForm,
        pluralFormLowercase
      }),
      disabled: isDisabled,
      "data-test-id": "create-object-dropdown",
      "data-coaching-tips": "import-button",
      "data-onboarding": "new-object-button",
      children: /*#__PURE__*/_jsxs(List, {
        children: [/*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(Button, {
            use: "tertiary-light",
            size: "small",
            onClick: onCreateObject,
            value: "create-object",
            "data-test-id": "create-object-dropdown-create-object",
            children: unescapedText('index.header.createObjectActionMenuOption.label')
          })
        }, 'create-object'), /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(PermissionTooltip, {
            tooltipKey: disabledTooltipKey,
            tooltipOptions: {
              objectTypeLabel: typeDef.pluralForm
            },
            placement: "bottom",
            disabled: !isImportDisabled,
            role: "tooltip",
            children: /*#__PURE__*/_jsx(Button, {
              use: "tertiary-light",
              size: "small",
              disabled: isImportDisabled,
              onClick: handleImportClick,
              value: "import",
              "data-test-id": "create-object-dropdown-import",
              children: unescapedText('contentToolbar.import')
            })
          })
        })]
      })
    })
  });
};
export const CreateObjectDropdownBehavior = props => {
  const accessScopes = getCreateAccessScopes(props.typeDef.objectTypeId);
  const hasCreateAccess = !accessScopes || props.hasAllScopes(...accessScopes);
  const isObjectRecordCreatorEnabled = useIsObjectRecordCreatorEnabled();
  const isDisabled = !hasCreateAccess || !isObjectRecordCreatorEnabled;
  return /*#__PURE__*/_jsx(CreateObjectDropdown, Object.assign({}, props, {
    isDisabled: isDisabled
  }));
};